export default {
  sp: 768
}
